<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { Primitive, type PrimitiveProps } from 'reka-ui'
import { cn } from '@/utils/utils'
import { type ButtonVariants, buttonVariants } from '.'
import { ArrowPathIcon } from '@heroicons/vue/24/solid'

interface Props extends PrimitiveProps {
  variant?: ButtonVariants['variant']
  size?: ButtonVariants['size']
  class?: HTMLAttributes['class']
  loading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  as: 'button',
})
</script>

<template>
  <Primitive
    data-slot="button"
    :as="as"
    :asChild="asChild"
    :class="cn(buttonVariants({ variant, size }), props.class, 'relative')"
  >
    <div class="relative flex items-center justify-center">
      <div :class="['flex items-center justify-center gap-x-2', { 'opacity-0': loading }]"><slot /></div>
      <template v-if="loading">
        <ArrowPathIcon class="absolute inset-0 m-auto w-4 h-4 animate-spin pointer-events-none" />
      </template>
    </div>
  </Primitive>
</template>
